module.exports = __webpack_public_path__ + "6ddb2f36ca16c1d5aeaf77ba9903f7d2.pdf";